import { SidePanel } from '@/shared/ui/SidePanelWrapper';
import { CenteredContent } from '@/shared/ui/layout/CenteredContent';
import { getWidgetStores, SectionWrapper } from '@/entities/widget';
import { EmptyState } from '@/shared/ui/EmptyState';
import { Button } from '@monksflow/monks-ui';
import { CircleAlertIcon } from 'lucide-react';
import type { ErrorStateProps } from './ErrorState.types';
import { useTranslation } from 'react-i18next';

export const ErrorState = ({ chatTitle, error, categoryChipColor }: ErrorStateProps) => {
  const { t } = useTranslation('analysis');

  // Store access via the widget binding seam.
  const { clearError } = getWidgetStores().widgetStore.useWidgetActions();
  const handleRetry = () => clearError();

  return (
    <SidePanel
      title={chatTitle}
      headerConfig={{
        chip: { label: t('fourCsWidget.errorState.createStrategy'), color: categoryChipColor },
      }}
    >
      <CenteredContent>
        <SectionWrapper compact>
          <EmptyState
            role="alert"
            className="py-12"
            icon={<CircleAlertIcon className="text-destructive" />}
            title={t('fourCsWidget.errorState.somethingWentWrong')}
            description={
              error && error.trim()
                ? error
                : t('fourCsWidget.errorState.anErrorOccurredWhileGenerating')
            }
          >
            <Button onClick={handleRetry}>{t('fourCsWidget.errorState.retry')}</Button>
          </EmptyState>
        </SectionWrapper>
      </CenteredContent>
    </SidePanel>
  );
};
